import { render, staticRenderFns } from "./compsycnasin.vue?vue&type=template&id=18076ee8"
import script from "./compsycnasin.vue?vue&type=script&lang=js"
export * from "./compsycnasin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports